translatedMessages = {
	aplicar: "Aplicar",
	cancelar: "Cancelar",
	desde: "Desde",
	hasta: "Até",
	custom: "Custom",
	do: "Do",
	lu: "Se",
	ma: "Te",
	mi: "Qu",
	ju: "Qu",
	vi: "Se",
	sa: "Sa",
	enero: "Janeiro",
	febrero: "Fevereiro",
	marzo: "Março",
	abril: "Abril",
	mayo: "Maio",
	junio: "Junho",
	julio: "Julho",
	agosto: "Agosto",
	septimbre: "Setembro",
	octubre: "Outubro",
	novimbre: "Novembro",
	decimbre: "Dezembro",
	seleccione: "Selecione",
	reserva_de_dispositivo: "Reserva de dispositivo",
	bloqueo_de_dispositivo: "Bloqueio de dispositivo",
	agregado_de_dispositivo_a_propuesta: "Anexo do dispositivo à proposta",
	agregado_de_dispositivo_a_pauta: "Anexo do dispositivo a pauta",
	detalle_de_reserva: "DETALHE DA RESERVA",
	motivo_de_bloque: "MOTIVO DO BLOQUEIO",
	campo_requerido: "Campo obrigatório",
	la_fecha_de_expiracion_debe_ser_mayor_a_hoy:
		"A data de validade deve ser maior que hoje",
	la_fecha_de_inicio_no_puede_ser_menor_a_hoy:
		"A data de início não pode ser menor que hoje",
	la_fecha_de_inicio_no_puede_ser_mayor_a_la_fecha_de_fin:
		"A data de início não pode ser maior que a data final",
	guardado: "Guardado",
	el_dispositivo_fue_agregado_con_exito:
		"O dispositivo foi adicionado com sucesso",
	descargar: "Baixar",
	listado_de_errores: "Lista de erros",
	soporte: "Suporte",
	soportes: "Suportes",
	detalle: "Detalhes",
	los_datos_se_han_guardado_con_exito: "Os dados foram salvos com sucesso",
	ha_ocurrido_un_error_al_guardar: "Ocorreu um erro ao salvar",
	arrastra_los_archivos_aqui_para_subirlos:
		"Arraste os arquivos aqui para enviá-los",
	su_navegador_no_admite_la_carga_de_archivos_de_arrastrar_y_soltar:
		"Seu navegador não suporta o recurso de arrastar e soltar arquivos.",
	utilice_el_siguiente_formulario_de_respaldo_para_cargar_sus_archivos_como_en_los_viejos_tiempos:
		"Use o seguinte formulário de respaldo para enviar seus arquivos como nos velhos tempos.",
	el_archivo_es_demasiado_grande_filesize_tamano_maximo_de_archivo:
		"O arquivo é muito grande ({{tamanho do arquivo}} MB). Tamanho máximo do arquivo: {{tamanho max.do arquivo}} MB.",
	no_puedes_subir_archivos_de_este_tipo:
		"Você não pode carregar arquivos deste tipo.",
	el_servidor_respondio_con_el_codigo_statusCode:
		"O servidor respondeu com o código {{código de status}}.",
	cancelar_carga: "Cancelar carga",
	estas_seguro_de_que_deseas_cancelar_esta_carga:
		"Tem certeza de que deseja cancelar esta carga",
	remover_archivo: "Remover arquivo",
	no_puedes_subir_mas_archivos: "Você não pode carregar mais arquivos.",
	enero_: "janeiro",
	febrero_: "fevereiro",
	marzo_: "março",
	abril_: "abril",
	mayo_: "maio",
	junio_: "junho",
	julio_: "julho",
	agosto_: "agosto",
	septiembre_: "setembro",
	octubre_: "outubro",
	noviembre_: "novembro",
	diciembre_: "dezembro",
	dispositivo: "Dispositivo",
	dispositivos: "Dispositivos",
	no_se_han_reservado_dispositivos: "Nenhum dispositivo foi reservado.",
	eliminado: "Removido",
	el_soporte_fue_eliminado_con_exito: " O suporte foi removido com sucesso",
	soporte_eliminado: "Suporte Removido",
	el_soporte_se_elimino_correctamente: "O suporte foi removido corretamente ",
	el_dispositivo_fue_eliminado_con_exito:
		"O dispositivo foi eliminado com sucesso",
	categorias_de_dispositivo: "CATEGORIAS DE DISPOSITIVO",
	nombre_de_tipo_de_dispositivo: "NOME DO TIPO DE DISPOSITIVO",
	ver_detalle: "Ver detalhe",
	street_view_no_esta_disponible_antes_de_seleccionar_ubicacion_en_el_mapa:
		"O Street View não está disponível antes de selecionar o local no mapa ",
	street_view_no_esta_disponible_para_el_lugar_seleccionado:
		"Street View não está disponível para o local selecionado",
	no_se_han_activado_campanas_aun_con_este_dispositivo:
		"Nenhuma campanha foi ativada mesmo com este dispositivo.",
	los_datos_fueron_eliminados_con_exito: "Os dados foram excluídos com sucesso",
	la_imagen_fue_subida_con_exito: "A imagem foi carregada com sucesso",
	la_imagen_fue_eliminada_con_exito: "A imagem foi removida com sucesso",
	el_archivo_fue_eliminado_con_exito: "O arquivo foi excluído com sucesso ",
	los_datos_fueron_actualizados_con_exito:
		"Os dados foram atualizados com sucesso",
	ha_ocurrido_un_error_al_eliminar_el_elemento:
		"ocorreu um erro ao excluir o elemento",
	no_hay_propuestas_creadas: "Não há propostas criadas.",
	agencia_creada_con_exito: "Agência criada com sucesso",
	cuenta_creada_con_exito: "Conta criada com sucesso",
	error: "Erro",
	direccion: "Endereço",
	fecha_inicio: "Data de início",
	fecha_fin: "Data final",
	cantidad: "Quantidade",
	cuenta: "Conta",
	agencia: "Agência",
	elementos_en_propuesta: "Elementos na proposta",
	fecha_expiracion: "Data de validade",
	acciones: "Ações",
	dar_de_baja: "Dar baixa",
	porciento_ocupacion: "% de Ocupação",
	tooltip_porciento_ocupacion: "Ocupação: [velho]{valor}[/]",
	la_fecha_de_expiracion_debe_ser_menor_o_igual_a_la_fecha_de_inicio:
		"A data de validade deve ser menor ou igual à data de início",
	ha_excedido_la_maxima_cantidad_total_de_elementos:
		"Você excedeu a máxima quantidade de elementos.",
	enviar_aprobacion_de_propuesta: "Enviar aprovação de propostas",
	enviar_cambios_en_propuesta: "Enviar alteraçõe da proposta",
	no_aplica: "Não se aplica",
	completar: "Completar",
	ayuda_soporte: "Ajuda? Suporte",
	no_hay_campannas_creadas: "Não há campanhas criadas",
	disponible: "Disponível",
	no_disponible: "Não disponível",
	la_fecha_inicio_mayor_expiracion:
		"A data de início deve ser maior que a data de expiração ",
	la_fecha_fin_mayor_inicio:
		"A data final deve ser maior ou igual que a data inicial",
	datos_de_propuesta: "Dados da proposta",
	datos_de_campana: "Dados da campanha",
	elementos_en_campana: "Elementos na campanha",
	listado_de_elementos_en_propuesta: "Lista de elementos na proposta",
	listado_de_elementos_en_campana: "Lista de elementos na campanha",
	titulo: "Título",
	contacto: "Contato",
	usuario_asignado: "Usuário atribuído",
	tipo_gestion: "Tipo Gestão",
	cliente_prospect: "Cliente / Perspectiva",
	fecha: "Data",
	cliente: "Cliente",
	prospect: "Perspectiva",
	tipo_de_contacto: "Tipo de contato",
	empresa: "Empresa",
	gestion: "Gestão",
	estado: "Estado",
	potencialidad: "Potencialidade",
	crear_contacto: "Criar contato",
	guardar: "Salvar",
	nombre: "Nomes",
	nombre_: "Nome",
	apellido: "Sobrenome",
	asignado_a: "Atribuído a",
	nombre_de_agencia: "Nome da agência",
	rubro: "Rubro",
	categoria: "Categoria",
	cargo: "Cargo",
	sub_rubro: "Sub artigo",
	email_empresa: "Email empresa",
	email: "Email",
	telefono_1: "Telefone 1",
	telefono_2: "Telefone 2",
	cumpleanios: "Aniversário",
	genero: "Sexo",
	estado_civil: "Estado civil",
	tiene_hijos: "Tem filhos",
	origen_de_contacto: "Origem do contato",
	url_sitio_web_de_la_empresa: "Site da empresa Url",
	observaciones: "Observações",
	ingrese_observaciones: "Inserir observações (opcional)",
	proveedor: "Fornecedor",
	pais: "País",
	ciudad: "Cidade",
	crear_gestion: "Criar gestão",
	no_hay_resultados: "Não há resultados",
	buscando: "Procurando...",
	para_buscar_ingrese_n_o_mas_caracteres:
		"Para pesquisar, digite 3 ou mais caracteres",
	masculino: "Masculino",
	femenino: "Feminino",
	si: "Sim",
	no: "Não",
	nombre_de_cuenta: "Nome da conta",
	nombre_de_provedor: "Nome do fornecedor",
	potencialidad_del_negocio: "Potencialidade de negócios",
	ejecutivo: "Executivo",
	date_format: "dd/mm/yyyy",
	datepicker: {
		days: [
			"Domingo",
			"Segunda-feira",
			"Terça-feira",
			"Quarta-feira",
			"Quinta-feira",
			"Sexta-feira",
			"Sábado",
			"Domingo",
		],
		daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
		daysMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa", "Do"],
		months: [
			"Janeiro",
			"Fevereiro",
			"Março",
			"Abril",
			"Maio",
			"Junho",
			"Julho",
			"Agosto",
			"Setembro",
			"Outubro",
			"Novembro",
			"Dezembro",
		],
		monthsShort: [
			"Jan",
			"Fev",
			"Mar",
			"Abr",
			"Mai",
			"Jun",
			"Jul",
			"Ago",
			"Set",
			"Out",
			"Nov",
			"Dez",
		],
		today: "Hoje",
		format: "dd/mm/yyyy",
		titleFormat: "MM yyyy",
	},
	tipo_de_gestion_realizada: "Tipo de gestão realizada",
	titulo_de_la_gestion: "Titulo da gestão",
	se_envio_obsequios: "Foi enviado presentes",
	obsequio: "Presente",
	importe: "Importância",
	moneda: "Moeda",
	la_gestion_fue_guardada_con_exito: "A gestão foi salva com sucesso",
	eliminar_gestion: "Eliminar gestão",
	editar_gestion: "Editar gestão",
	eliminar: "Eliminar",
	esta_seguro_que_desea_eliminar_la_gestion_nombre_gestion:
		"Tem certeza de que deseja remover a gestão (xxxxxx)?",
	faltan_datos_a_completar: "Faltam dados para concluir",
	medidas_visibles_mayores_a_finales:
		"As medidas visíveis não podem ser maiores que as medidas finais",
	actualizado: "Atualizado",
	telefono: "Telefone",
	esta_seguro_que_desea_eliminar_al_contacto:
		"Tem certeza de que deseja excluir o contato xxxxxx",
	eliminar_contacto: "Eliminar contato",
	gestiones: "Gestões",
	listado_de_gestiones: "Lista de gestões",
	buscar: "Buscar",
	todos: "Tudo",
	ninguno: "Nenhum",
	fecha_de_creacion_del_gestion: "Data de criação da gestão",
	logo: "Logo",
	tipo_de_empresa: "Tipo de empresa",
	eliminar_agencia: "Excluir agencia",
	eliminar_cuenta: "Excluir conta",
	eliminar_proveedor: "Excluir fornecedor",
	esta_seguro_que_desea_eliminar_la_empresa:
		"Tem certeza de que deseja excluir a empresa (xxxxxx)",
	contactos: "Contactos",
	listado_de_contactos: "Lista de contatos",
	empresas: "Empresas",
	listado_de_empresas: "Lista de empresas",
	crear_agencia: "Criar agência",
	crear_cuenta: "Criar conta",
	editar_agencia: "Editar agencia",
	crear_proveedor: "Criar fornecedor",
	tipo_de_proveedor: "Tipo de fornecedor",
	clasificacion: "Classificação",
	sub_rublo: "Sub item",
	soltar_imagenes_para_cargar_click_aqui:
		"Solte imagens para carregar ou clique aqui",
	soltar_imagenes_o_cargar: "Arrastre o haga click aquí para adjuntar imagen",
	cargar_imagen: "Haga click aquí para adjuntar imagen",
	eliminar_logo: "Excluir logo",
	editar_cuenta: "Editar conta",
	editar_proveedor: "Editar fornecedor",
	nuevos_contactos: "Novos contatos",
	ultima_actualizacion: "Última atualização",
	gestion_realizada_a: "Gestão realizada a",
	los_datos_se_han_eliminado_con_exito: "Os dados foram excluído com sucesso",
	gestiones_historicas: "Gestiones históricas",
	gestiones_futuras: "Gestiones futuras",
	email_personal: "Email personal",
	validar: "Validar",
	realizo_una_gestion_con: "realizou uma gestão com",
	gestion_realizada_por: "Gestão realizada por",
	no_hay_gestiones_realizadas: "Não há passos dados",
	proveedores: "Provedores",
	total_obsequios: "Total de presentes",
	resumen_de_gestiones: "Resumo dos procedimentos",
	metricas_de_gestiones_comeriales: "Métricas de gestão de negócios",
	gestiones_totales: "Gestão total",
	reunion_prom_semana: "Reunião média por semana",
	propuestas_enviadas: "Propostas submetidas",
	conversion_en_porcentaje: "Conversão em porcentagem",
	forma_de_contacto: "Contatado por",
	tipo_de_cliente: "Tipo de cliente",
	modulo: "Módulo",
	nombre_completo: "Nome completo",
	mensaje: "Mensagem",
	enviar: "Mandar",
	ultimos_contactos_gestionados: "Últimos contatos geridos",
	listado_de_contactos: "Listado de contatos",
	ultimas_cuentas_trabajadas: "ÚLTIMAS CONTAS TRABALHADAS",
	ultimos_contactos_trabajados: "ÚLTIMOS CONTATOS GERIDOS",
	proximas_gestiones: "PRÓXIMAS ATIVIDADES",
	gestiones_pendientes_confirmacion: "ATIVIDADES PENDENTES DE CONFIRMAÇÃO",
	gestiones_historicas: "ATIVIDADES HISTÓRICAS",
	confirmar: "CONFIRMAR",
	confirmar_: "Confirmar",
	editar: "Editar",
	no_cuentas_trabajadas: "Não há contas trabalhadas",
	no_contactos_gestionados: "Nenhum contato gerenciado",
	no_informado: "Desinformado",
	no_proximas_gestiones: "Sem atividades futuras",
	no_gestiones_pendientes_confirmacion:
		"Nenhuma atividade pendente de confirmação",
	no_gestiones_historicas: "No hay gestiones hostoricas",
	historial: "REGISTRO",
	propuestas_pendientes_respuesta: "PROPOSTAS PENDENTES DE RESPOSTA",
	proximas_campannas: "PRÓXIMAS CAMPANHAS",
	no_hay_gestiones_futuras_cargadas: "Nenhuma atividade futura carregada",
	no_hay_gestiones_historicas_cargadas: "Nenhuma atividade histórica carregada",
	realizado_por: "Feito por",
	propuesta: "Proposta",
	ver: "VER",
	campañas_realizadas: "Campanhas realizadas",
	tasa_de_conversion: "Taxa de conversão",
	promedio_de_reuniones_semanales: "Média de reuniões semanais",
	gestiones_realizadas: "Atividades realizadas",
	no_hay_propuestas_pendientes_de_respuesta:
		"Nenhuma proposta com resposta pendente",
	no_hay_proximas_campannas: "Não há próximas campanhas",
	seguro_desea_confirmar_la_gestion:
		"¿Você com certeza deseja confirmar a atividade (xxxxxx)?",
	confirmar_gestion: "Confirme a atividade",
	el_numero_de_telefono_es_incorrecto: "O numero de telefone está errado",
	otro: "Outro",
	tipos_de_empresas: "Tipos de empresas",
	sin_contactos_asociados: "Nenhum contato associado",
	sin_gestiones_asociadas: "Sem atividade associada",
	ultima_gestion: "Ultima atividade",
	no_hay_ultimos_contactos_gestionados: "Nenhum último contato gerenciado",
	no_hay_contactos: "Sem contatos",
	usuario: "Usuário",
	tipo_de_gestion: "Tipo de actividad",
	gestiones_por_usuario_top_15: "Atividades por usuário (TOP 15)",
	montos_en_propuestas_generadas: "Quantidades em propostas geradas",
	montos_en_campanas_ejecutadas: "Valores em campanhas executadas",
	evolucion_de_las_gestiones: "Evolução das atividades",
	gestiones_por_cuenta_top_20: "Atividades por conta (top 20)",
	crear_empresa: "Criar empresa",
	campanas_generadas: "Campanhas geradas",
	tasa_de_conversion: "Taxa de conversão",
	no_hay_empresas_creadas: "Nenhuma empresa criada",
	editar_empresa: "Editar empresa",
	habilitar_agencia: "Habilitar agência",
	habilitar_cuenta: "Habilitar conta",
	habilitar_proveedor: "Habilitar provedor",
	deshabilitar_agencia: "Desativar agencia",
	deshabilitar_cuenta: "Desativar cuenta",
	deshabilitar_proveedor: "Desativar proveedor",
	esta_seguro_que_desea_eliminar_sucursal:
		"¿Seguro desea eliminar la sucursal (xxxxxx)?",
	esta_seguro_que_desea_eliminar_agente:
		"¿Seguro desea eliminar el agente (xxxxxx)?",
	eliminar_sucursal: "Eliminar Sucursal",
	eliminar_agente: "Eliminar Agente",
	editar_agente: "Editar Agente",
	editar_sucursal: "Editar Sucursal",
	provincia: "Provincia",
	esta_seguro_que_desea_habilitar_la_empresa:
		"¿Você tem certeza que deseja habilitar a empresa (xxxxxx)?",
	esta_seguro_que_desea_deshabilitar_la_empresa:
		"¿Você tem certeza que deseja desativar a empresa (xxxxxx)?",
	deshabilitar: "Desativar",
	tipo_soporte_ya_existe: "O nome selecionado já existe.",
	sin_asignar: "Não atribuído",
	varios: "Varios",
	item: "ITEM",
	total: "TOTAL",
	motivo: "RAZÃO",
	asignados_total: "ATRIBUÍDO / TOTAL",
	ubicacion_tipo_dispositivo: "LOCALIZAÇÃO / TIPO DE DISPOSITIVO",
	la_campanna_no_tiene_dispositivos_asociados:
		"A campanha não tem dispositivos associados",
	asignar_motivo: "Atribuir razão",
	ver_motivos: "Ver razão",
	ver_mapa: "Ver mapa",
	motivos: "Razãos",
	ingrese_nuevo_motivo: "Ingrese nuevo motivo",
	agregar_motivo: "Adicionar Razão",
	cant: "QTY.",
	ubicacion: "LOCALIZAÇÃO",
	tipo_de_soporte: "TIPO DE SUPORTE",
	tipo_de_soporte_: "Tipo de suporte",
	no_encontrado_resultados: "Não foram encontrados resultados",
	valor: "Valor",
	agregar: "Adicionar",
	eliminar_elementos: "Remover itens",
	seguro_desea_eliminar_los_elementos:
		"¿Você tem certeza que deseja deletar os itens?",
	fecha_inicio_fin: "DATA DE INÍCIO ~ DATA DE FINALIZAÇÃO",
	date_format_D_MMM_YYYY: "D-MMM-YYYY",
	eliminar_motivos: "Remova os motivos",
	seguro_desea_eliminar_los_motivos:
		"¿Você com certeza deseja remover os motivos?",
	motivo: "Motivo",
	cantidad_de_elementos: "Número de elementos",
	buscar_direccion_o_patente: "Endereço de pesquisa ou patente",
	periodo: "Período",
	no_hay_datos_disponibles: "Sem dados disponíveis",
	id: "ID",
	lleva_prueba_color: "FAÇA O TESTE DE COR",
	tipo_de_dispositivo: "Tipo de dispositivo",
	color: "Cor",
	agregar_editar_motivo: "ADICIONAR / EDITAR RAZÃO",
	asignacion_de_motivos: "Atribuição de razãos",
	tipos_de_soporte: "Tipos de suporte",
	hora_inicio: "Hora de início",
	hora_fin: "Fim do tempo",
	dias: "Días",
	por_tipo_de_soporte: "POR TIPO DE SUPORTE",
	por_motivo: "POR RAZÃO",
	filtros: "Filtros",
	sin_motivo_asignado: "Nenhum motivo atribuído",
	confirmar_campana: "Confirme a campanha",
	seguro_decea_confirmar_campana:
		"¿Você com certeza deseja confirmar a campanha? Você não poderá editar itens novamente ou atribuir motivos.",
	initial_of_weeksdays: ["2", "3", "4", "5", "6", "S", "D"],
	accion_eliminar: "Excluir ação",
	seguro_que_desea_eliminar_duplicado_de_XXXX:
		"¿Você tem certeza que deseja remover duplicado de XXXX?",
	debe_selecciona_minimo_un_dia: "Você deve selecionar pelo menos um dia",
	campanna: "Campanha",
	sustrato: "Substrato",
	tecnologia: "Tecnología",
	fecha_de_inicio: "Data de início",
	medida_final: "Medida final",
	duracion_maxima: "Duração máxima",
	formato_digital: "Formato digital",
	tiene_rotacion: "Tem rotação",
	medida_visible: "Medição visível",
	ver_dispositivo: "VER DISPOSITIVO",
	descargar_original: "BAIXAR ORIGINAL",
	descargar_archivo_en_baja: "BAIXAR ARQUIVO EM BAIXO",
	no_hay_elementos_asociados: "Não há elementos associados",
	no_hay_elementos_disponibles: "Nenhum item disponível",
	jpg_en_baja: "Jpg em baixo",
	video_en_baja: "Video em baixo",
	arrastre_o_haga_click_aqui: "Arraste ou clique aqui",
	descargar_ficha: "BAIXAR FOLHA",
	analogico: "Analógico",
	digital: "Digital",
	link_de_descarga: "Link para baixar",
	fecha_aprobacion_prueba_color: "Data de aprovação do teste de cor",
	fecha_envio_imprenta: "Fecha envío imprenta",
	fecha_finalizacion_impresion: "Impressão da data de envio",
	segundos: "Segundos",
	formato_de_imagen_no_valido: "Formato de imagem inválido",
	formato_de_video_no_valido: "Formato de vídeo inválido",
	imprenta: "Impressão",
	solo_admite_un_archivo_maximo: "Suporta apenas um arquivo",
	solo_admite_archivos_jpg_jpeg_bmp_png_gif_tiff:
		"Suporta apenas arquivos .jpg, .jpeg, .bmp, .png, .gif, .tiff",
	solo_admite_archivos_wma_mp4_avi_mov:
		"Suporta apenas arquivos .wma, .mp4, .avi, .mov",
	el_archivo_excede_a_10_mb_en_su_tamano: "O arquivo excede 10 Mb de tamanho",
	ha_ocurrido_un_error_al_descargar_el_archivo:
		"Ocorreu um erro ao baixar o arquivo",
	poi: "POI",
	puntos_de_interes: "Pontos de interesse",
	observacion_medidas: "Observações medidas",
	sub_categoria: "Subcategoria",
	disponibilidad: "Disponibilidade",
	ots: "Ots",
	date_range_picker_locale: {
		sunday: "Do",
		monday: "Se",
		tuesday: "Te",
		wednesday: "Qa",
		thursday: "Qi",
		friday: "Sx",
		saturday: "Sa",
		today: "Hoje",
		ok: "Aplique",
	},
	referencias: "Referências",
	no_se_han_agregado_soportes_a_la_propuesta:
		"Nenhum suporte foi adicionado à proposta",
	editar_fechas: "Editar datas",
	ver_comentarios: "Ver comentários",
	seleccionados: "Selecionado",
	medidas_comerciales_alto_x_ancho: "Medidas comerciais (alto x largura):",
	eliminar_figura_seleccionada: "Excluir figura selecionada",
	eliminar_todas_las_figuras: "Exclua todas as formas",
	confirma_que_desea_borrar_el_dato: "¿Confirme que deseja excluir os dados?",
	la_tarjeta_volvera_estado_correspondiente_borraran_todos_los_datos_ingresados_posteriormente:
		"O cartão retornará ao estado correspondente e todos os dados inseridos posteriormente serão apagados",
	se_modifico_dato_desea_guardar_mantener_tarjeta_en_estado_actual_guardar_mover_estado_correspondiente:
		"Um dado foi modificado, deseja salvar e manter o cartão no estado atual ou salvar e mover para o estado correspondente?",
	de_ser_necesario_se_borraran_los_datos_existentes_de_estados_posteriores:
		"Se necessário, os dados existentes de estados posteriores serão excluídos.",
	max: "Max",
	min: "Min",
	el_valor_minimo_no_puede_ser_vacio: "O valor mínimo não pode estar vazio",
	el_valor_maximo_no_puede_ser_vacio: "O valor máximo não pode estar vazio",
	el_valor_minimo_no_puede_superar_al_valor_maximo:
		"O valor mínimo não pode exceder o valor máximo",
	el_valor_minimo_no_puede_ser_menor_al_tope_minimo_existente:
		"O valor mínimo não pode ser menor que o limite mínimo existente",
	el_valor_maximo_no_puede_ser_mayor_al_tope_maximo_existente:
		"O valor máximo não pode ser maior que o limite máximo existente",
	el_valor_minimo_no_puede_ser_mayor_al_tope_maximo_existente:
		"O valor mínimo não pode ser maior que o limite máximo existente",
	el_valor_maximo_no_puede_ser_menor_al_tope_minimo_existente:
		"O valor máximo não pode ser menor que o limite mínimo existente",
	ocultar_todos: "Esconda tudo",
	mostrar_todos: "Mostre tudo",
	radio: "Radio",
	guardar_mantener: "Salvar e manter",
	guardar_mover: "Salvar e mover",
	agregar_comentario: "Adicionar comentário",
	debe_seleccionar_solo_uno_listado: "Você deve selecionar apenas um da lista",
	el_tipo_soporte_seleccionado_listado_corresponde_este:
		"O tipo de mídia selecionado na lista não corresponde a este",
	enviar_propuesta: "Enviar proposta",
	editar_propuesta: "Editar proposta",
	liberar_propuesta: "Liberar proposta",
	convertir_a_campana: "Converter para campanha",
	estado_de_propuesta_actualizado: "Status da proposta atualizado",
	error_al_actualizar_propuesta: "Erro ao atualizar proposta",
	desea_dar_de_baja_esta_propuesta: "¿Você quer cancelar esta proposta?",
	desea_convertir_esta_propuesta_a_campaña:
		"¿Você deseja converter esta proposta em uma campanha?",
	aprobacion_de_propuesta: "Aprovação da proposta",
	ingresar_mensaje_opcional: "Digite a mensagem (Opcional)",
	enviada: "Enviei",
	propuesta_enviada_correctamente: "Proposta enviada com sucesso",
	agregado: "Agregar",
	fecha_de_vencimiento_de_propuesta: "Data de expiração da proposta",
	el_formato_no_es_correcto: "O formato não está correto",
	este_campo_es_requerido: "Este campo é obrigatório",
	el_campo_no_puede_tener_mas_de_n_caracteres:
		"O campo não pode ter mais de {###} caracteres.",
	la_fecha_de_vencimiento_debe_ser_posterior_o_igual_a_hoy:
		"A data de vencimento deve ser posterior ou igual a hoje.",
	quitar_elementos: "Remover itens",
	el_soporte_quitar_esta_mas_propuesta_desea_quitar_todas_sus_instancias_del_listado:
		"¿O elemento a ser excluído está mais de uma vez na proposta, você deseja remover todas as suas instâncias da lista?",
	confirma_que_desea_quitar_dispositivo_propuesta:
		"¿Confirme que deseja remover o item da proposta?",
	editar_seleccionados: "Editar selecionado",
	soportes_seleccionados: "Soportes seleccionados",
	debe_seleccionar_un_rango_de_fechas: "Debe seleccionar un rango de fechas",
	ha_ocurrido_un_error_al_actualizar_intentelo_mas_tarde:
		"Ocorreu um erro durante a atualização. Por favor, tente novamen",
	proposal_comments: "Comentários",
	proposal_old_comments: "Comentários anteriores",
	comment_view_more: "Ver comentario",
	comment_view_less: "Ocultar comentario",
	el_listado_del_tipo_soporte_esta_completo:
		"A lista do tipo de suporte está completa",
	la_propuesta_contiene_al_menos_un_elemento_no_disponible:
		"A proposta contém pelo menos um elemento não disponível",
	soportes_asignados: "Tipo de elementos atribuídos",
	datos_de_la_propuesta: "Dados da proposta",
	seleccionar_soporte: "Selecione o tipo de elementos",
	direccion_o_patente: "Endereço ou patente",
	checking_approve: "Aprovar",
	checking_reject: "Recusar",
	soportes_no_disponibles: "Tipos de elemento não disponível",
	revisar_disponibilidad: "Verificar disponibilidade",
	al_convertir_a_campana_se_descartaran_los_soportes_no_disponibles_estas_seguro:
		"Na hora da conversão para campanha, os tipos de elementos não disponíveis serão descartados, tem certeza?",
	si_descartar_no_disponibles: "Sim, descarte não disponível",
	no_editar_propuesta: "Não, editar proposta",
	checking_request_changes: "Solicitar mudanças",
	checking_saved: "Salvou",
	saved_changes: "Mudanças feitas com sucesso",
	checking_strategy_tab: "Estrategia",
	checking_proposaList_tab: "Lista de elementos na proposta",
	checking_map_tab: "Mapa de tipos de elemento",
	listado_de_elementos: "Listado de elementos",
	estrategia: "Estrategia",
	escribe_aqui: "Escreva aqui...",
	descartar: "Descartar",
	vista_previa: "Vista previa",
	No_se_admite_propuesta_sin_soportes: "Proposta sem suportes não é permitida",
	checking_modal_accept: "Aceitar",
	checking_modal_cancel: "Cancelar",
	checking_modal_text: "¿Você com certeza deseja aprovar a proposta?",
	existen_soportes_incompletos: "Existem suportes incompletos",
	listado_de_soportes: "Lista de suportes",
	tipo_dispositivo_ubicacion: "Tipo de dispositvo - Localização",
	solo_puede_subir_n_archivos_simultaneos:
		"Você só pode carregar {n} arquivos simultaneamente",
};
